import React from 'react';
import {
  faCalendar,
  faUser,
  faFileContract,
} from '@fortawesome/free-solid-svg-icons';
import ModuleInterface from '../../modules.interface';
import { Navigation, NavigationItem } from '../../components/Navigation';
import { Groups } from '../../groups.enum';
import Seminars from './features/Seminars';
import Hosts from './features/Hosts';
import ViewSeminar from './features/ViewSeminar';
import EditSeminar from './features/EditSeminar';
import NewSeminar from './features/NewSeminar';
import EditHost from './features/EditHost';
import Editor from "./features/staticContent/Editor";
import StaticContent from "./features/StaticContent";

const config: ModuleInterface = {
  name: 'seminars',
  title: 'Seminare',
  permissions: [],
  groups: [Groups.HOST, Groups.ADMIN],
  navigation: [
    <Navigation label="Seminare" key="navigation">
      <NavigationItem
        label="Veranstaltungen"
        icon={faCalendar}
        path="/seminars/seminars"
      />
      <NavigationItem
        label="Seminarleiter"
        icon={faUser}
        path="/seminars/hosts"
        groups={[Groups.ADMIN]}
      />
      <NavigationItem
        label="Statische Inhalte"
        icon={faFileContract}
        path="/seminars/staticContent"
      />
      <NavigationItem
        label="Seminar Login"
        path="https://seminar.elektrolotse.de/host/login"
      />
    </Navigation>,
  ],
  routes: [
    {
      path: '/addSeminar',
      component: NewSeminar,
    },
    {
      path: '/staticContent/editor',
      component: Editor,
    },
    {
      path: '/seminars/:id/edit',
      component: EditSeminar,
    },
    {
      path: '/seminars/:id',
      component: ViewSeminar,
    },
    {
      path: '/seminars',
      component: Seminars,
    },
    {
      path: '/hosts/:id',
      component: EditHost,
    },
    {
      path: '/hosts',
      component: Hosts,
    },
    {
      path: '/staticContent',
      component: StaticContent,
    },
    {
      path: '/',
      component: Seminars,
    },
  ],
};
export default config;
